import React, { useState, useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import {api} from '../Login/axiosConfig';
import { Box, Grid, Typography, Card, Button, IconButton, Chip, Skeleton, Avatar, Divider,Paper, CardContent, Rating, CircularProgress, useMediaQuery, useTheme, Tooltip } from '@mui/material';
import { Facebook, Instagram, X, LinkedIn, YouTube } from '@mui/icons-material';
import { Dialog, DialogActions, DialogContent, DialogTitle, Checkbox, FormControlLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Header1 from '../Header/Header1';
import Footer from '../Footer/Footer';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ReportIcon from '@mui/icons-material/Report';
import ShareButton from "../Share/ShareButton";
import Footer2 from '../Footer/Footer2';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import PostRecommendations from '../Recommendations/PostRecommendations';
import avatar from './default-avatar.png'
import ShareIcon from '@mui/icons-material/Share';
import FlagIcon from '@mui/icons-material/Flag';
import { styled } from '@mui/system';
import ShowBookedUsers from './ShowBookedUsers';
import { PersonOutline } from '@mui/icons-material';
import DeleteIcon from "@mui/icons-material/Delete";
import GenerateOTPButton from '../OTP/GenerateOTPButton';
import FeedbackFormMyPosts from '../Feedback/FeedbackFormMyPosts';
import GoogleMeetLogo from './GoogleMeetImage.png';
import ZoomMeetLogo from './ZoomMeetImage.png';
import TeamsMeetLogo from './TeamsMeetImage.png';
import YouTubeEmbed from '../UserProfile/YouTubeEmbed';
import CancelSessionPostButton from '../Cancellations/CancellSessionPostButton';
import MeetingGuidelines from '../Guidelines/MeetingGuidelines';
import ViewsLikesAnalytics from './ViewsLikesAnalytics';
import GenerateTokenButton from '../Agora/GenerateTokenButton';
import JoinNowButton from '../Agora/JoinNowPublisherButton';
import { formatDateWithSuffix } from '../utils/formatDate';
import { formatTimeToAMPM } from '../utils/formatTime';
import EditIcon from "@mui/icons-material/Edit";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PeopleIcon from "@mui/icons-material/People";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";



const API_URL = process.env.REACT_APP_API_URL;



const MyPostTabDetails = ({ onLogout }) => {
  const { userId } = useAuth();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);


  const { id } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [action, setAction] = useState(null);
  const location = useLocation();
  const [feedbackData, setFeedbackData] = useState([]);
  const [bookingCreated, setBookingCreated] = useState(false)
  const paymentStatus = location.state?.paymentStatus || 'unknown';  // Default to 'unknown' if not provided
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [loadingSeconds, setLoadingSeconds] = useState(0);


  const [bookedUsers, setBookedUsers] = useState([]);

  const [openDialog, setOpenDialog] = useState(false); // To control the dialog's visibility
  const [isChecked, setIsChecked] = useState(false); // To track checkbox state


  useEffect(() => {
          let timer;
        
          if (loading) {
            setLoadingSeconds(0); // reset timer
            timer = setInterval(() => {
              setLoadingSeconds(prev => prev + 1);
            }, 1000);
          } else {
            clearInterval(timer);
            setLoadingSeconds(0); // optional reset after done
          }
        
          return () => clearInterval(timer); // cleanup on unmount or loading = false
        }, [loading]);

  const handleJoinClick = () => {
    setOpenDialog(true); // Open the dialog
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked); // Update checkbox state
  };

  const handleConfirmAndJoin = () => {
    if (isChecked) {
      window.open(course.meeting_link, '_blank'); // Open in a new tab
      setOpenDialog(false); // Close the dialog
    } else {
      alert('Please confirm that you understand the instructions.');
    }
  };





  useEffect(() => {
  const fetchBookedUsers = async () => {
    setLoading(true); // Start loading

    try {
      const response = await api.get(`${API_URL}/booked_users/`, {
        params: { post_id: id },
      });

      if (response.status === 200) {
        setBookedUsers(response.data);
      }
    } catch (error) {
      console.error("Error fetching booked users:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  if (id) {
    fetchBookedUsers();
  }
}, [id]);



  const getLogo = (platform) => {
    switch (platform) {
      case 'googleMeet':
        return GoogleMeetLogo;
      case 'zoom':
        return ZoomMeetLogo;
      case 'microsoftTeams':
        return TeamsMeetLogo;
      default:
        return null; // Optionally, you can return a default image or a placeholder here
    }
  };


  const getPlatformName = (platform) => {
    switch (platform) {
      case 'googleMeet':
        return 'Google Meet';
      case 'zoom':
        return 'Zoom';
      case 'microsoftTeams':
        return 'Microsoft Teams';
      default:
        return null;
    }
  };

  useEffect(() => {
  const fetchData = async () => {
    setLoading(true); // Start loading

    try {
      const response = await api.get(`${API_URL}/get_posted_data/`, {
        params: { post_id: id },
      });
      setCourse(response.data[0]);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // Stop loading regardless of success or error
    }
  };

  fetchData();
}, [id, userId]);
  // Depend on 'id' and 'userId' to ensure the data and view count is fetched only once

  const handleDelete = async () => {
  setLoading(true); // Start loading

  try {
    const response = await api.delete(`${API_URL}/delete_post/`, {
      params: { post_id: id },
    });

    if (response.status === 200) {
      alert("Post deleted successfully!");
      // Update the UI here if needed (e.g., navigate away or refresh list)
      // Refresh the page
      navigate("/");
    }
  } catch (error) {
    console.error("Error deleting post:", error);
    alert("Failed to delete the post");
  } finally {
    setLoading(false); // Stop loading
  }
};




  useEffect(() => {
  const getUserPostInteraction = async () => {
    setLoading(true); // Start loading

    try {
      const response = await api.get(
        `${API_URL}/get_user_post_interaction/`,
        {
          params: {
            user_id: userId,
            post_id: id,
          },
        }
      );
      setAction(response.data.action); // Set the action (like, dislike, or null)
    } catch (error) {
      setAction(null);
      console.error("Error fetching user post interaction:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  getUserPostInteraction();
}, [userId, id]);


  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  useEffect(() => {
    const fetchUserFeedback = async () => {
      try {
        setLoading(true);
        const response = await api.post(`${API_URL}/get_user_feedback_for_post/`, { post_id: id });
        setFeedbackData(response.data);
      } catch (err) {
        setError('Failed to fetch feedback. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchUserFeedback();
    }
  }, [id]);


  if (loading) {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(3px)',
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress
          size={60}
          thickness={6}
          sx={{
            color: 'transparent',
            '& .MuiCircularProgress-circle': {
              stroke: 'url(#better-gradient)',
            },
          }}
        />

        {/* Gradient definition */}
        <svg width="0" height="0">
          <defs>
            <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#f30b96ff" />
              <stop offset="50%" stopColor="#221ce0ff" />
              <stop offset="100%" stopColor="#0eacebff" />
            </linearGradient>
          </defs>
        </svg>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            color: '#fff',
            textShadow: '0 1px 3px rgba(0,0,0,0.7)',
          }}
        >
          Loading Session Details... ({loadingSeconds} sec)
        </Typography>
      </Box>
    </Box>
  );
}


  if (error) {
    return <Typography color="error">{error}</Typography>;
  }




  if (!course) {
  return (
    <>
      <Typography variant="h6" sx={{ textAlign: "center", padding: "2rem" }}>
        Loading...
      </Typography>

      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 2000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(3px)',
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress
            size={60}
            thickness={6}
            sx={{
              color: 'transparent',
              '& .MuiCircularProgress-circle': {
                stroke: 'url(#better-gradient)',
              },
            }}
          />

          {/* Gradient definition */}
          <svg width="0" height="0">
            <defs>
              <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#f30b96ff" />
                <stop offset="50%" stopColor="#221ce0ff" />
                <stop offset="100%" stopColor="#0eacebff" />
              </linearGradient>
            </defs>
          </svg>

          <Typography
            variant="h6"
            sx={{
              mt: 2,
              color: '#fff',
              textShadow: '0 1px 3px rgba(0,0,0,0.7)',
            }}
          >
            Loading Session Details... ({loadingSeconds} sec)
          </Typography>
        </Box>
      </Box>
    </>
  );
}


  const formatStartTime = (time) => {
    const [hours, minutes] = time.split(':');
    const dateObj = new Date();
    dateObj.setHours(hours);
    dateObj.setMinutes(minutes);

    // Format using Intl.DateTimeFormat
    const formatter = new Intl.DateTimeFormat('en-US', {
      hour: '2-digit', minute: '2-digit', hour12: true
    });

    return formatter.format(dateObj); // returns time in AM/PM format
  }

  const formatDuration = (durationInMinutes) => {
    const hours = Math.floor(durationInMinutes / 60);
    const minutes = durationInMinutes % 60;

    // If duration is less than an hour, only show minutes
    if (hours > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
    }

    return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
  };

  const formatExperience = (experience) => {
    // If experience exists and is in the format HH:MM
    if (experience) {
      let minutes = experience.split(':')[0];  // Extract the minute value before ":"
      return `${minutes} min`;
    } else {
      return "New user";  // If no experience, return "New user"
    }
  }


  const {
    topic_name, section_name, subsection_name, description, language, date, start_time,
    duration, seats_left, total_seats, name, surname, profile_picture,
    about, rating, experience, id: cardId, price, meeting_link, host_meeting_link,
    facebook, instagram, x, linkedin, youtube, likes, dislikes, specialized_fields, roles, meeting_platform, user_id, media_url, media_type, status
  } = course;

  const durationFormatted = formatDuration(duration)
  const teacherRating = rating || "Not rated yet";
  const formattedStartTime = formatStartTime(start_time);
  const formatedExperience = formatExperience(experience)


  const handleCourseDetailsNavigation = (courseId, bookedUsers) => {
    navigate(`/show-booked-users/${courseId}`, { state: { bookedUsers } });
  };




  const handleShareClick = () => {
  };

  const handleRedirect = () => {
    navigate('/meeting-guidelines');  // Redirect to meeting guidelines page
  };


  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleEditClick = () => {
    navigate(`/expert-edit-post/${id}`);
  };

   const handleReschedule = () => {
    navigate(`/expert-reschedule-post/${id}`);
  };

  const handleViewParticipants = () => {
    navigate(`/expert-participants-view/${id}`);
  };

  const canEditOrDelete = bookedUsers && bookedUsers.length === 0;

  return (
    <div>
      <Header1 userId={userId} onLogout={onLogout} />
      

      <Box sx={{
        backgroundColor: "#000000",
        minHeight: "100vh",
        marginTop: "50px", marginBottom: "100px",
        px: { xs: 1, sm: 3, md: 5 }, // Responsive horizontal padding
        overflowX: "hidden",         // 💥 Prevent horizontal scroll
        width: "100%",
      }}>
        <Grid
          container
          spacing={3}
          justifyContent="center"
          sx={{
            backgroundColor: "#000000",
            width: "100%",
            margin: 0,
            padding: 0,
            overflowX: "hidden", // 💥 Just in case something leaks here
          }}
        >

          <Grid item xs={12} sm={10} md={8} lg={8}>
            <Box sx={{
              position: 'relative',
              padding: { xs: "1.5rem", sm: "2rem", md: "3rem", lg: "4rem" },// Responsive padding
              backgroundColor: "#2222", // Darker background for modern look
              color: "#fff",
              borderRadius: "16px",
              height: "100%",
              boxSizing: "border-box",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
              },
            }}>


              {media_type === 'video' ? (
                <Box
                  component="video"
                  src={media_url}
                  controls
                  sx={{ width: '100%', borderRadius: '12px', boxShadow: 3, mb: 2 }}
                />
              ) : (
                <Box
                  component="img"
                  src={media_url}
                  alt="media"
                  sx={{ width: '100%', borderRadius: '12px', boxShadow: 3, mb: 2 }}
                />
              )}
<Box sx={{ position: 'relative', display: 'flex', justifyContent: 'flex-end' }}>
  <ShareButton postUrl={`${window.location.origin}/share/post/${id}`} />
</Box>

<Typography
                                              variant="h6"
                                              sx={{
                                                  fontWeight: 400,
                                                  mt: "1.5rem",
                                                  mb: "1.5rem",
                                                  color: "#fff",
                                                  letterSpacing: 1,
                                                  textAlign: "left", // 👈 changed from "center" to "left"
                                                  fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                                                  fontSize: {
                                                      xs: '1rem',
                                                      sm: '1.2rem',
                                                      md: '1.2rem',
                                                      lg: '1.2rem',
                                                  },
                                                  lineHeight: 1.6,
                                                  "&:hover": {
                                                      color: '#1E90FF',
                                                  },
                                              }}
                                          >
                                              {topic_name}
                                          </Typography>
              

              <Box
                sx={{
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: 2, // replaces manual margin for spacing
                  pt: '1rem',
                }}
              >
                {/* <Avatar
                  src={profile_picture ? `${API_URL}${profile_picture}` : '/default-avatar.png'}
                  alt={`${name || 'User'} ${surname || ''}`}
                  sx={{
                    width: 50,
                    height: 50,
                    border: '2px solid #fff',
                    boxShadow: '0 0 8px rgba(0,0,0,0.3)',
                  }}
                /> */}

                <Avatar
                                                                                            sx={{ width: 50, height: 50, bgcolor: '#0a2e57ff', fontSize: 28 }}
                                                                                            src={profile_picture || undefined}
                                                                                          >
                                                                                            {!profile_picture && name
                                                                                              ? name.charAt(0).toUpperCase()
                                                                                              : null}
                                                                                          </Avatar>

                 <Tooltip title="Click to view" placement="bottom">
                                                    <Typography
                    variant="h6"
                    onClick={() => navigate(`/expert-profile?expert_id=${user_id}`)}
                    sx={{
                        fontWeight: 'bold',
                        color: '#fff',
                        fontFamily: "'Helvetica', sans-serif",
                        letterSpacing: '0.15em',
                        fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },
                        cursor: 'pointer',
                        transition: 'color 0.3s ease-in-out',
                        '&:hover': {
                            color: '#1E90FF',
                        },
                    }}
                >
                    {name || 'Name'} {surname || 'Surname'}
                </Typography>
                
                                                </Tooltip>
              </Box>

              
                              {/* Description */}
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            sx={{
                                                                background: 'rgba(255, 255, 255, 0.05)',
                                                                borderLeft: '4px solid #1976d2',
                                                                padding: 2,
                                                                mt:2,
                                                                borderRadius: '8px',
                                                                fontSize: '0.95rem',
                                                                lineHeight: 1.6,
                                                                color: '#e0e0e0',
                                                                boxShadow: 'inset 0 0 5px rgba(255,255,255,0.05)',
                                                                whiteSpace: 'pre-wrap',
                                                                wordBreak: 'break-word',
                                                            }}
                                                        >
                                                            {description || 'No description provided.'}
                                                        </Typography>
                                                    </Grid>





              {/* Grid of details */}
              <Grid container spacing={2} justifyContent="left" sx={{ mt: 1, mb: 5 }}>
                {/* Date + Time + Duration */}
                <Grid item xs={12} sm="auto">
  <Typography
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: { xs: 0.5, sm: 1 },
      fontWeight: 600,
      fontSize: { xs: '0.875rem', sm: '1rem' },
      color: '#ffffff',
      background: 'linear-gradient(135deg, #2079c2ff 0%, #1f2c33ff 100%)',
      px: { xs: 1.5, sm: 2 },
      py: { xs: 0.25, sm: 0.5 },
      borderRadius: '18px',
      boxShadow: '0 2px 10px rgba(48, 71, 83, 0.4)',
      whiteSpace: 'nowrap',
      textShadow: '0 1px 2px rgba(0,0,0,0.4)',
      letterSpacing: 0.4,
      userSelect: 'none',
      width: 'fit-content',
      maxWidth: '100%',
      overflowX: 'auto', // Prevents overflow on very small screens
      cursor: 'default',
    }}
  >
    🗓
    <span>
      {formatTimeToAMPM(start_time)} • {formatDateWithSuffix(date)} • {durationFormatted}
    </span>
  </Typography>
</Grid>


                {/* Language */}
                <Grid item>
                  <Typography
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 1,
                      fontWeight: '600',
                      fontSize: '1rem',
                      color: '#ffffff',
                      background: 'linear-gradient(135deg, #c78b1cff, #27231aff)',
                      px: 2,
                      py: 0.5,
                      borderRadius: '20px',
                      boxShadow: '0 0 10px rgba(160, 124, 45, 0.3)',
                      letterSpacing: 0.3,
                      whiteSpace: 'nowrap',
                      textShadow: '0 0 4px rgba(0,0,0,0.25)',
                      userSelect: 'none',
                      cursor: 'default',
                      width: 'fit-content',
                    }}
                  >
                    🗣 {language || "N/A"}
                  </Typography>
                </Grid>

                {/* Price */}
                <Grid item>
                  <Typography
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 1,
                      fontWeight: '600',
                      fontSize: '1rem',
                      color: '#ffffff',
                      background: 'linear-gradient(135deg, #bcc71cff, #27231aff)',
                      px: 2,
                      py: 0.5,
                      borderRadius: '20px',
                      boxShadow: '0 0 10px rgba(160, 124, 45, 0.3)',
                      letterSpacing: 0.3,
                      whiteSpace: 'nowrap',
                      textShadow: '0 0 4px rgba(0,0,0,0.25)',
                      userSelect: 'none',
                      cursor: 'default',
                      width: 'fit-content',
                    }}
                  >
                    ₹{price}
                  </Typography>
                </Grid>
              </Grid>

<Box
  sx={{
    p: 4,
    borderRadius: 4,
    backgroundColor: "#1a1a1a",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center", // center everything horizontally
    gap: 3,
    boxShadow: "0 8px 20px rgba(0,0,0,0.6)",
    border: "1px solid rgba(255,255,255,0.1)",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "4px",
      background: "linear-gradient(90deg, #0ecb81, #f0ad4e, #0ecb81)",
      animation: "slide 3s linear infinite",
    },
    "@keyframes slide": {
      "0%": { transform: "translateX(-100%)" },
      "100%": { transform: "translateX(100%)" },
    },
  }}
>
  {/* Centered Title */}
  <Typography
    variant="h5"
    sx={{ 
      fontWeight: "bold", 
      textAlign: "center", 
      letterSpacing: 1, 
      color: "#fff",
      textShadow: "0 0 6px rgba(255,255,255,0.3)"
    }}
  >
    Expert Control Panel
  </Typography>

  {/* Stylish Status Badge */}
  <Chip
    label={`Status: ${status}`}
    sx={{
      fontWeight: "bold",
      fontSize: "0.95rem",
      px: 3,
      py: 1,
      borderRadius: "50px",
      color: "#fff",
      background: status === "under-review" 
        ? "linear-gradient(45deg, #f0ad4e, #ffce4e)" 
        : "linear-gradient(45deg, #0ecb81, #21e0a0)",
      boxShadow: "0 2px 12px rgba(0,0,0,0.4)",
    }}
  />

  {/* Divider */}
  <Divider sx={{ width: "80%", borderColor: "rgba(255,255,255,0.2)" }} />

  {/* Horizontal Buttons */}
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: 2,
    }}
  >
    {canEditOrDelete && status === "under-review" &&(
      <Tooltip title="Edit this post">
        <Button
          variant="contained"
          color="primary"
          startIcon={<EditIcon />}
          onClick={handleEditClick}
          sx={{
            textTransform: "none",
            px: 3,
            transition: "0.3s",
            "&:hover": { transform: "scale(1.05)", boxShadow: "0 4px 16px rgba(0,0,0,0.4)" },
          }}
        >
          Edit Post
        </Button>
      </Tooltip>
    )}

    {canEditOrDelete && (
      <Tooltip title="Reschedule this post">
        <Button
          variant="outlined"
          color="warning"
          startIcon={<ScheduleIcon />}
          onClick={handleReschedule}
          sx={{
            textTransform: "none",
            px: 3,
            "&:hover": { backgroundColor: "rgba(255,173,78,0.1)", transform: "scale(1.05)" },
          }}
        >
          Reschedule
        </Button>
      </Tooltip>
    )}

    {canEditOrDelete && status === "under-review" && (
      <Tooltip title="Delete this post">
        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={() => setOpenDeleteDialog(true)}
          sx={{
            textTransform: "none",
            px: 3,
            "&:hover": { backgroundColor: "rgba(255,77,77,0.1)", transform: "scale(1.05)" },
          }}
        >
          Delete
        </Button>
      </Tooltip>
    )}

    <Tooltip title="View participants booked for this post">
      <Button
        variant="outlined"
        color="info"
        startIcon={<PeopleIcon />}
        onClick={handleViewParticipants}
        sx={{
          textTransform: "none",
          px: 3,
          "&:hover": { backgroundColor: "rgba(0,123,255,0.1)", transform: "scale(1.05)" },
        }}
      >
        View Participants
      </Button>
    </Tooltip>

    <Tooltip title={host_meeting_link ? "Join the session" : "Meeting link not available"}>
      <Button
        variant="contained"
        color="success"
        startIcon={<MeetingRoomIcon />}
        href={host_meeting_link || "#"}
        target="_blank"
        rel="noopener noreferrer"
        disabled={!host_meeting_link}
        sx={{
          textTransform: "none",
          px: 3,
          "&:hover": { transform: "scale(1.05)", boxShadow: "0 4px 16px rgba(0,0,0,0.4)" },
        }}
      >
        Join Session
      </Button>
    </Tooltip>
  </Box>
</Box>

             



            </Box>
            <Dialog
              open={openDeleteDialog}
              onClose={() => setOpenDeleteDialog(false)}
              PaperProps={{
                sx: {
                  borderRadius: "16px",
                  padding: 2,
                  backgroundColor: "#000000",
                  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.6)",
                  maxWidth: 420,
                  mx: 'auto',
                },
              }}
            >
              <DialogTitle
                sx={{
                  fontWeight: 'bold',
                  fontSize: '1.5rem',
                  textAlign: 'center',
                  color: '#ff5f5f',
                  pb: 1,
                }}
              >
                Delete ?
              </DialogTitle>

              <DialogContent sx={{ textAlign: 'center', px: 3 }}>
                <Typography sx={{ fontSize: '1rem', color: '#ccc' }}>
                  Are you sure you want to Delete? This action cannot be undone.
                </Typography>
              </DialogContent>

              <DialogActions sx={{ justifyContent: 'center', gap: 2, mt: 2 }}>
                <Button
                  onClick={() => setOpenDeleteDialog(false)}
                  sx={{
                    borderRadius: '25px',
                    padding: '0.6rem 1.5rem',
                    backgroundColor: '#333',
                    color: '#ddd',
                    textTransform: 'none',
                    "&:hover": {
                      backgroundColor: '#444',
                    },
                  }}
                >
                  Go Back
                </Button>

                <Button
                  onClick={() => {
                    handleDelete(); // actual cancel logic
                    setOpenDeleteDialog(false);
                  }}
                  variant="contained"
                  sx={{
                    borderRadius: '25px',
                    padding: '0.6rem 1.8rem',
                    textTransform: 'none',
                    background: "linear-gradient(45deg, #ff4d4d, #d93636)",
                    fontWeight: 'bold',
                    letterSpacing: 1,
                    color: '#fff',
                    "&:hover": {
                      transform: 'scale(1.05)',
                      boxShadow: '0 8px 20px rgba(255, 77, 77, 0.4)',
                    },
                  }}
                >
                  Confirm Delete
                </Button>
              </DialogActions>
            </Dialog>

          </Grid>





          <div>



            <Dialog
              open={openDialog}
              onClose={() => setOpenDialog(false)}
              PaperProps={{
                sx: {
                  backgroundColor: '#1e1e1e',
                  color: '#e0e0e0',
                  borderRadius: 2,
                  minWidth: { xs: '90%', sm: 600 },
                  maxHeight: '90vh',
                },
              }}
            >
              <DialogContent sx={{ pt: 3, pb: 1, px: 3 }}>
                <MeetingGuidelines />

                <Box sx={{ mt: 3 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                        sx={{
                          color: '#bb86fc',
                          '&.Mui-checked': {
                            color: '#bb86fc',
                          },
                        }}
                      />
                    }
                    label={
                      <Typography variant="body2" sx={{ color: '#e0e0e0', letterSpacing: 2 }}>
                        I acknowledge that I have read, understood, and agree to all the terms and conditions outlined above.
                      </Typography>
                    }
                  />
                </Box>
              </DialogContent>

              <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button
                  onClick={() => setOpenDialog(false)}
                  variant="outlined"
                  color="secondary"
                  sx={{ letterSpacing: 3 }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleConfirmAndJoin}
                  variant="contained"
                  color="primary"
                  disabled={!isChecked}
                  sx={{
                    backgroundColor: !isChecked ? '#555' : '#1976d2',
                    letterSpacing: 3,
                    '&:hover': {
                      backgroundColor: !isChecked ? '#555' : '#1565c0',
                    },
                  }}
                >
                  Confirm and Join
                </Button>
              </DialogActions>
            </Dialog>
          </div>

        </Grid>


      </Box>


      <IconButton
        onClick={scrollToTop}
        sx={{ position: 'fixed', bottom: 16, right: 16, backgroundColor: 'white', color: 'black' }}>
        <ArrowUpwardIcon />
      </IconButton>
      <Footer2 />
    </div>
  );
};

export default MyPostTabDetails;